module.exports = __webpack_public_path__ + "img/video-15.503e868b.png";